/**
 * @packageDocumentation
 * @module Datetime
 */
import { zonedTimeToUtc } from 'date-fns-tz';
/**
 * Function to get a date string for a given zoned date
 * @param timezoneSimulatedDate: Date to use
 * @param timezone: Timezone for the conversion
 *
 * @return string
 */
var getDateStringFromZonedDate = function (timezoneSimulatedDate, timezone) {
    var utcSimulatedDate = zonedTimeToUtc(timezoneSimulatedDate, timezone);
    return utcSimulatedDate.toISOString();
};
export default getDateStringFromZonedDate;
//# sourceMappingURL=getDateStringFromZonedDate.js.map